import _isEmpty from 'lodash/isEmpty';
import debugWallet from '../helpers/debugWallet.js';
import applyTenantCalculatorConfigs from './applyTenantCalculatorConfigs.js';
import applyDrSettings from './applyDrSettings.js';
import updateCalculatorConfig from './updateCalculatorConfig.js';
import applyFallbackDrSettings from './applyFallbackDrSettings.js';
import buildPaymentCalculationUrl from './buildPaymentCalculationUrl.js';
async function modifyExternalConfig(externalConfig) {
  let listing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let paymentCalculationFetcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let drSettingsFetcher = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let paymentIncentivesFetcher = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let payments = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  let config;
  let listingWithOwnerInfo = {};
  const type = listing?.type || 'Used';
  let vehicleType = type[0].toUpperCase() + type.slice(1); // should be capitalized already, this is just in case
  let isCertified = false;
  if (vehicleType === 'Certified') {
    vehicleType = 'Used'; // 'Certified' is not a valid option in the DR settings API response
    isCertified = true;
  }

  // Add isCertified to the listing object
  const enrichedListing = {
    ...listing,
    isCertified
  };
  const {
    interactions: {
      hasUpdatedWallet = false,
      paymentEmphasis = false,
      hasOpenedWallet = false
    } = {}
  } = payments;
  const isWalletActive = hasUpdatedWallet || paymentEmphasis || hasOpenedWallet;
  let drSettings = {};
  const hasDrSettings = () => !(_isEmpty(drSettings) || drSettings?.error);
  const getOwnerInfo = function () {
    let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      address = {},
      name,
      phone
    } = settings || {};
    return {
      address,
      name,
      phone
    };
  };
  const createListingWithOwnerInfo = (listingData, settingsData, ecommerce) => ecommerce === 'BOA' ? {
    ...listingData,
    ownerInfo: getOwnerInfo(settingsData) || {}
  } : listingData;

  // Accelerate or BOA Tenant
  if (externalConfig.ecommerce === 'Accelerate' || externalConfig.ecommerce === 'BOA') {
    let modifiedExternalConfig;

    // Setting the sponsor for BOA to update DRSettings endpoint URl
    const sponsor = externalConfig.sponsor ?? (externalConfig.ecommerce === 'BOA' ? 'boa' : undefined);

    // Fetch DR settings for this dealer
    drSettings = (await drSettingsFetcher.fetch(externalConfig?.dealerId, sponsor, vehicleType)) || {};
    debugWallet('UDS', 'DR Settings Payload', drSettings);
    debugWallet('UDS', 'External config', externalConfig);

    // Update listingWithOwnerInfo with the fetched drSettings - BOA only
    listingWithOwnerInfo = createListingWithOwnerInfo(enrichedListing, drSettings, externalConfig.ecommerce);

    // Apply DR settings we retrieved to the calculator configuration, if available
    modifiedExternalConfig = hasDrSettings() ? applyDrSettings(externalConfig, drSettings, vehicleType, listingWithOwnerInfo) : externalConfig;

    // If wallet is active, update the configuration based on the payments info from it
    if (isWalletActive) {
      modifiedExternalConfig = await updateCalculatorConfig(payments, modifiedExternalConfig);
    }
    debugWallet('UDS', 'Config after applying DR Settings Payload', modifiedExternalConfig);

    // Overlay tenant defaults to any missing values
    config = await applyTenantCalculatorConfigs(modifiedExternalConfig, listingWithOwnerInfo);

    // Apply fallback DR settings to any missing values
    config = applyFallbackDrSettings(config, vehicleType);
  } else {
    // For non-BOA/Accelerate tenants, only basic listing data needed
    listingWithOwnerInfo = enrichedListing;

    // Ecommerce and PSX tenant defaults
    config = await applyTenantCalculatorConfigs(externalConfig, listingWithOwnerInfo);
  }

  // Build payment calculation URL if not already built
  if (!config?.paymentCalculationUrl && !config?.enableExternalPaymentFetch) {
    // Should be called only once to build URL
    config.paymentCalculationUrl = await buildPaymentCalculationUrl(config, listingWithOwnerInfo, hasDrSettings() ? drSettings : {}, vehicleType);
  }
  return {
    ...config,
    paymentCalculationFetcher,
    paymentIncentivesFetcher
  };
}
export { modifyExternalConfig as default };
